/* Built In Imports */
import { forwardRef, useEffect, useState } from 'react';
import NextLink from 'next/link';
/* External Imports */
import {
  Box
} from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';

/* Internal Imports */
/* Components */
import SectionTitle from '@components/Headings/SectionTitle';
import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';

/* Services */
/* Styles */

/**
 * Renders ChypSadhanaDetail Component
 *
 * @param {object} sectionContent - Data from api
 * @param {string} region - Region of page
 * @param {string} lang - Language of page
 * @returns
 */


const ChypContactus = ({ sectionContent, region, lang }) => {
  return (
    <>
      <Box m={{base:'16px auto 30px auto', md:'70px auto 60px auto'}} width={{ base: '100%', md: 'auto' }}>
        <Box>
          <SectionTitle titleObj={sectionContent[0]} />
        </Box>
        <Box
          fontFamily="FedraSansStd-book"
          maxW={{ base: '90%', md: '660px' }}
          m="0 auto"
        >
          <StructuredTextParser
            str={render(sectionContent[1]?.body)}
            region={region}
            lang={lang}
            mt="30px"
            color={'#000000'}
            lineHeight={'1.7'}
            fontSize="16px"
            textAlign={'center'}
            className="event-text contactus"
          />
        </Box>
        
        <style global jsx>
          {`
            .contactus p a {
              text-decoration: none;
              color: #CF4520;
              border-bottom: none;
            }
            @media (max-width: 768px) {
            }
          `}
        </style>
      </Box>
    </>
  );
};

export default ChypContactus;
